import { NavbarService } from "./../../services/navbar-service.service";
import { AuthService } from "./../../services/auth.service";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit {
  searchForm = new FormGroup({
    fokoCode: new FormControl()
  });

  constructor(
    public auth: AuthService,
    public navbarService: NavbarService,
    public router: Router,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {}

  onSubmit() {
    this.navbarService
      .checkFokoExistence(this.searchForm.value.fokoCode)
      .snapshotChanges()
      .take(1)
      .subscribe(data => {
        const foko = data.payload.val();
        console.log(foko);
        if (foko) {
          this.router.navigate(["game", "pu", data.key]);
        } else {
          this.openSnack("This Foko does not exist. Please check your Foko code and try again.", "Dismiss");
        }
      });
  }

  openSnack(message: string, action?: string) {
    this.snackBar.open(message, action, {
      duration: 2500
    });
  }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/navbar/navbar.component.ts